<template>
  <BaseSimpleModal
    :width="isMobile ? '360px' : '512px'"
    class="livelo-modal-notify"
    has-close-button
    @close="closeModal"
  >
    <template #body>
      <img
        class="image m-0"
        :src="imgModal"
        alt="Imagem mostrando colaboração entre o Prata Digital e a Livelo"
      >
    </template>
    <template #actions>
      <label class="checkbox">
        <input
          v-model="shouldStopShowing"
          type="checkbox"
        >
        Não desejo ver esse aviso novamente.
      </label>

      <div class="buttons ml-auto">
        <button
          class="button"
          @click="closeModal"
        >
          Fechar
        </button>
        <button
          class="button is-success"
          @click="goToTransferPage"
        >
          Transferir minhas Pratas
        </button>
      </div>
    </template>
  </BaseSimpleModal>
</template>

<script>
import { mapGetters } from 'vuex';

import imgMobile from '@/assets/image/modal-livelo-mobile.png';
import imgDesktop from '@/assets/image/modal-livelo-desktop.png';
import BaseSimpleModal from '@/components/BaseSimpleModal.vue';

export default {
  name: 'LoginNotifyLiveloModal',
  components: {
    BaseSimpleModal,
  },
  data: () => ({
    shouldStopShowing: false,
    imgDesktop,
    imgMobile,
  }),
  computed: {
    ...mapGetters({
      isMobile: 'app/isMobile',
    }),
    imgModal() {
      return this.isMobile
        ? this.imgMobile
        : this.imgDesktop;
    },
  },
  methods: {
    goToTransferPage() {
      const { href } = this.$router.resolve({ name: 'livelo-statement' });
      window.open(href, '_blank');
    },
    closeModal() {
      if (this.shouldStopShowing) {
        localStorage.setItem('shouldStopShowingLoginLiveloModal', this.shouldStopShowing);
      }
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/src/statementVariables';

.livelo-modal-notify {
  &::v-deep {
    .modal-content {
      gap: 24px;

      &__header {
        h1 {
          font-weight: 700;
          font-size: 20px;
          line-height: 28px;
          color: map.get($stone-types, "800");
        }
      }

      &__body {
        .highlight {
          text-align: center;
          font-weight: 700;
          color: #000;
          margin-bottom: 8px;
        }

        img {
          display: inline-block;
          margin: 0 auto 24px auto;
          width: 327px;
          height: 333px;
        }

        p {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: map.get($stone-types, "500");
        }
      }

      &__actions {
        label {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: map.get($stone-types, "500");
        }
      }
    }

    @media only screen and (min-width: 1024px) {
      .modal-content {
        &__header {
          h1 {
            font-size: 24px;
            line-height: 32px;
          }
        }

        &__body {
          img {
            display: inline-block;
            margin: 0 0 24px 0;
            width: 464px;
            height: 297px;
          }
        }

        &__actions {
          flex-wrap: wrap;
          button {
            flex-grow: 0;
            flex-shrink: 0;
          }
          label {
            flex-basis: 100%;
            flex-shrink: 0;
          }
        }
      }
    }
  }
}

</style>
